import {observable, action, runInAction, toJS} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import marketingResourcePoolAPI from '../apis/marketingResourcePoolAPI'
import alertMessage from '../utils/alertMessage'

export default class MarketingResourcePoolStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []

  /*SearchResult start*/
  @observable searchItem = {
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []
  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await marketingResourcePoolAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  //Status 下拉列表
  @observable statusList = []
  @observable typeList = []
  @action
  async onGetStatus(params) {
    if(params==='marketType') {
      this.statusList = []
    } else {
      this.typeList = []
    }
    try {
      const response = await marketingResourcePoolAPI.getStatus(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          if(params==='marketType') {
            this.statusList = data
          } else {
            this.typeList = data
          }
        } else {
          alertMessage.error('获取失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('获取异常！'+err.message+'')
      runInAction(() => {
      })
    }
  }

  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await marketingResourcePoolAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('获取失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('获取异常！' +err.message+ '')
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  /*add*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await marketingResourcePoolAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null
  @observable isFetchingEdit = false
  @observable reportPageCondition = []

  @action
  async onGetJobAction(params) {
    this.isFetchingEdit = true
    try {
      const response = await marketingResourcePoolAPI.getAction(params)
      runInAction(() => {
        this.isFetchingEdit = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
          this.reportPageCondition = data?.conditions
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingEdit = false
      })
    }
  }

  
  /*status*/
  @action
  async onChangeStatus(apiID) {
    this.isFetching = true
    try {
      const response = await marketingResourcePoolAPI.statusAction(apiID)
      runInAction(() => {
        this.isFetching = false
        // if (response.data.code === 200) {
        if (response.data.code === 0) {
          alertMessage.success('成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('失败！' + response.data.data + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await marketingResourcePoolAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      ...this.searchItem,
      'page': pageNo,
      'size': pageSize,
    })
  }
  
  @observable reportConditionOperatorList = []
  @action
  async getReportConditions() {
    try {
      const response = await marketingResourcePoolAPI.getReportConditions()
      const {data, code} = response.data

      runInAction(() => {
        if (code === 0) {
          this.reportConditionOperatorList = data
        } else {
        }
      })
    } catch (err) {
      runInAction(() => {
      })
    }
  }
  @observable reportSqlList = []
  @action
  async analysisReportSql(params) {
    try {
      const response = await marketingResourcePoolAPI.analysisReportSql(params)
      const {data, code} = response.data
      const {metaData} = data
      runInAction(() => {
        if (code === 0) {
          this.reportSqlList = metaData
        } else {
        }
      })
      return response.data
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  
  /*SearchResult start*/
  @observable isFetchingDetails = false
  @observable pageSizeDetails  = PAGE_SIZE_DEFAULT
  @observable pageNoDetails = 1
  @observable currIndexDetails  = 0
  @observable itemCountDetails  = 0
  @observable searchItemDetails = {
    'pageNo': this.pageNoDetails,
    'pageSize': this.pageSizeDetails,
  }
  @observable detailsList = []
  @action
  async onSearchListAction(params, isSearchBtn) {
    this.isFetchingDetails = true
    this.detailsList = []
    this.pageNoDetails = params.pageNo
    this.pageSizeDetails = params.pageSize
    this.itemCountDetails = 0
    this.headerList = null
    try {
      const response = await marketingResourcePoolAPI.getListAction(params)
      runInAction(() => {
        this.isFetchingDetails = false
        if (response.data.code === 0) {
          this.detailsList = response.data.data?.list || []
          this.itemCountDetails = response.data.data?.total
          this.searchItemDetails = params
          if( response.data.data?.list?.length > 0) {
            this.headerList = this.reportPageCondition.map(item=>item.name)?.filter(d=>d !== 'id')?.map(a=> {return {
              "name": a,
              "show": true
            }})
          } else {
            this.onGetListHeaderAction(params?.poolId)
          }
          const ids = response.data.data?.list?.map(a=>{return a?.id})
          if(isSearchBtn) {
            this.selectedRowKeys = []
            this.selectedRows = []
            this.isAll = false
          }
          if(this.isAll) {
            this.onChangeSelectedRowKeys(this.selectedRowKeys.concat(ids),this.selectedRows.concat(response.data.data?.list))
          }
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingDetails = false
      })
    }
  }
  @action
  onChangeIsFetching(value){
    this.isFetchingDetails = value
    this.isFetchingEdit = value
  }

  @observable headerList = null
  @action
  async onGetListHeaderAction(params) {
    this.isFetchingDetails = true
    try {
      const response = await marketingResourcePoolAPI.getListHeaderAction(params)
      runInAction(() => {
        this.isFetchingDetails = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.headerList = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingDetails = false
      })
    }
  }

  @action
  onChangePageNumDetailsAction(pageNo, pageSize) {
    if (this.pageNoDetails === pageNo && (!pageSize || this.pageSizeDetails === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNoDetails = pageNo
      this.pageSizeDetails = pageSize
    })
    this.onSearchListAction({
      ...this.searchItemDetails,
      'pageNo': pageNo,
      'pageSize': pageSize,
    })
  }
  
  /*add*/
  @action
  async onImportAction(params) {
    this.isFetchingDetails = true
    try {
      const response = await marketingResourcePoolAPI.importAction(params)
      runInAction(() => {
        this.isFetchingDetails = false
        if (response.data?.code === 0) {
          alertMessage.success('导入成功！')
        } else {
          alertMessage.error('导入失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingDetails = false
      })
    }
  }
    /*checkbox*/
    @observable selectedRowKeys=[]
    @observable selectedPhoneList=[]
    @observable selectedEmailList=[]
    @observable selectedRows=[]
    @action
    onChangeSelectedRowKeys(selectedRowKeys,selectedRows){
      const arr = this.selectedRowKeys.concat(selectedRowKeys)
      this.selectedRowKeys= [...new Set(arr.filter(Boolean))]

      const phoneArr = this.selectedPhoneList.concat(selectedRows?.map(item=>item['手机号码']))
      this.selectedPhoneList= [...new Set(phoneArr.filter(Boolean))]

      const emailArr = this.selectedEmailList.concat(selectedRows?.map(item=>item['邮件地址']))
      this.selectedEmailList= [...new Set(emailArr.filter(Boolean))]

      // this.selectedRows=[...new Map(this.selectedRows.concat(selectedRows).map(item => [item?.id, item])).values()]
    }
    @action
    onCutSelectedRowKeys(selectedRowKeys,selectedRows){
      // 确保 selectedRowKeys 是数组
      const keysToRemove = Array.isArray(selectedRowKeys) ? selectedRowKeys : [selectedRowKeys]
      this.selectedRowKeys = this.selectedRowKeys.filter(item => !keysToRemove?.includes(item))

      this.selectedPhoneList= this.selectedPhoneList.filter(item => !selectedRows?.map(item=>item['手机号码'])?.includes(item))
      this.selectedEmailList= this.selectedEmailList.filter(item => !selectedRows?.map(item=>item['邮件地址'])?.includes(item))

      // this.selectedRows= this.selectedRows.filter(obj => !selectedRowKeys?.has(obj?.id))
    }
    @action
    onClearSelectedRowKeys(selectedRowKeys,selectedRows){
      this.selectedRowKeys= selectedRowKeys
      this.selectedPhoneList= selectedRows?.map(item=>item['手机号码'])
      this.selectedEmailList= selectedRows?.map(item=>item['邮件地址'])

      // this.selectedRows= selectedRows
    }
    @observable isAll = false
    @action
    onChangeIsAll(value) {
      this.isAll = value
    }
  
  @action
  async getInSearchList(params) {
    try {
      const response = await marketingResourcePoolAPI.inSearchAction(params)
      const {code} = response.data

      runInAction(() => {
        if (code === 0) {
        } else {
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
}
